var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHealthinfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.47,
    height: 42,
    viewBox: "0 0 33.47 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "medical-history",
    transform: "translate(-0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    "data-name": "Group 292",
    transform: "translate(0.004 3.455)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    "data-name": "Group 291"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M26.746,42.167H4.379A4.38,4.38,0,0,0,0,46.542v29.75a4.38,4.38,0,0,0,4.375,4.375h24.5c2.415,0,4.451-1.014,4.375-4.375.533-15.59-.076-21.45,0-30.242C33.05,43.054,32.16,41.866,26.746,42.167ZM31.5,76.292c0,2.3-1.175,2.625-2.625,2.625H4.379a2.625,2.625,0,0,1-2.625-2.625V46.542a2.625,2.625,0,0,1,2.625-2.625H26.746c2.742.027,4.82.225,4.758,2.133C31.5,57.583,31.53,76.066,31.5,76.292Z",
    transform: "translate(-0.004 -42.122)",
    fill: "#f6781b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296",
    transform: "translate(4.379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_295",
    "data-name": "Group 295"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M57.023.005Q56.93,0,56.836,0a3.5,3.5,0,0,0-3.5,3.5v.875h1.75V3.5a1.729,1.729,0,0,1,.546-1.271,1.75,1.75,0,0,1,1.3-.479,1.853,1.853,0,0,1,1.655,1.9v9.476a1.75,1.75,0,1,1-3.5,0V7h-1.75v6.125a3.5,3.5,0,1,0,7,0V3.649A3.578,3.578,0,0,0,57.023.005Z",
    transform: "translate(-53.337)",
    fill: "#f6781b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_298",
    "data-name": "Group 298",
    transform: "translate(6.129 9.625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M93.045,117.341H81.67v1.75H93.045a.875.875,0,0,1,.875.875v14.875a.875.875,0,0,1-.875.875H77.295a.875.875,0,0,1-.875-.875v-8.75H74.67v8.75a2.625,2.625,0,0,0,2.625,2.625h15.75a2.625,2.625,0,0,0,2.625-2.625V119.966A2.625,2.625,0,0,0,93.045,117.341Z",
    transform: "translate(-74.67 -117.341)",
    fill: "#f6781b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317",
    transform: "translate(11.37 14.743)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_318",
    "data-name": "Group 318"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M163,170.674a3,3,0,1,0,3,3A3,3,0,0,0,163,170.674Zm0,4.5a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,163,175.174Z",
    transform: "translate(-157.753 -170.674)",
    fill: "#0060a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M134,245.341h-1.5a4.5,4.5,0,0,0-4.5,4.5h1.5a3,3,0,0,1,3-3H134a3,3,0,0,1,3,3h1.5A4.5,4.5,0,0,0,134,245.341Z",
    transform: "translate(-128.004 -240.091)",
    fill: "#0060a6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312",
    transform: "translate(3.504 36.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_271",
    "data-name": "Rectangle 271",
    width: 8.75,
    height: 1.75,
    fill: "#0060a6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_314",
    "data-name": "Group 314",
    transform: "translate(3.504 33.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_313",
    "data-name": "Group 313"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_272",
    "data-name": "Rectangle 272",
    width: 5.25,
    height: 1.75,
    fill: "#0060a6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    "data-name": "Group 316",
    transform: "translate(14.004 36.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_315",
    "data-name": "Group 315"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_273",
    "data-name": "Rectangle 273",
    width: 1.75,
    height: 1.75,
    fill: "#0060a6"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHealthinfo);
export default __webpack_public_path__ + "static/media/icon_healthinfo.00de9e20d8a5b2d09d498262040088b0.svg";
export { ForwardRef as ReactComponent };